module.exports = __webpack_public_path__ + "static/img/2_2@2x.362b30e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_2@2x.png
// module id = 9lRI
// module chunks = 8